































































import { Component, Vue, Prop } from 'vue-property-decorator';
import machineryRentalsRepository from '@/modules/machinery/services/machineryRentalsRepository';
import notificationService from '@/services/notificationService';

import ImageUploadPopup from '@/modules/files/components/ImageUploadPopup.vue';
import Popup from '@/components/default/Popup.vue';
import Card from '@/components/default/Card.vue';
import settings from '@/settings.json';

import { DxFileUploader } from 'devextreme-vue/file-uploader';

@Component({
  components: {
    ImageUploadPopup,
    Popup,
    Card,
    DxFileUploader,
  },
})
export default class MachineryRentalImagesTable extends Vue {
    @Prop({required: true})
    private rentalId!: string;

    private images: IMachineryRentalImage[] = [];
    private saving: boolean = false;
    private loading: boolean = false;
    private showUploadPopup: boolean = false;
    private showImagePopup: boolean = false;
    private selectedImage: IMachineryRentalImage | null = null;

      private guidList: any[] = [];

    private mounted() {
        this.loadData();
    }

    private async loadData() {
        try {
            this.loading = true;
            const result = await machineryRentalsRepository.getImages(this.rentalId);
            this.images = result.data;
        } catch (err) {
            notificationService.showErrorMessage('Afbeeldingen konden niet opgehaald worden!');
        } finally {
            this.loading = false;
        }
    }

    private async uploadFile(file: any) {
        await this.uploadImage({
            blob: file,
            name: file.name,
        });
    }

    private async uploadImage(e: any) {
        try {
            this.saving = true;
            const result = (await machineryRentalsRepository
                .uploadImage(this.$route.params.id, e.blob, e.filename));
            this.showUploadPopup = false;
            this.loadData();
            notificationService.saved();
        } catch (err) {
            notificationService.showErrorMessage('failed to upload image');
        } finally {
            this.saving = false;
        }
    }

    private async deleteImage(filename: string) {
        try {
            if (confirm('Bent u zeker dat u deze foto wenst te verwijderen?')) {
                await machineryRentalsRepository.deleteImage(this.rentalId, filename);
                this.loadData();
                notificationService.saved();
            }
        } catch (err) {
            notificationService.failedToSave();
        }
    }

    private async toggleImage(image: IMachineryRentalImage) {
        try {
            await machineryRentalsRepository.updateImage({
                rentalId: this.rentalId,
                filename: image.filename,
                includeInContract: !image.includeInContract,
            });

            const i = this.images.find((o) => o.filename === image.filename);
            if (i) {
                i.includeInContract = !i.includeInContract;
            }

            notificationService.saved();
        } catch (err) {
            notificationService.failedToSave();
        }
    }

    private showImage(image: IMachineryRentalImage) {
        this.selectedImage = image;
        this.showImagePopup = true;
    }

    get imageUrl() {
        if (this.selectedImage === null) {
            return '';
        }

        return settings.api
            + '/api/Machinery/Rentals/'
            + this.rentalId
            + '/image/' + this.selectedImage.filename;
    }
}
